module.exports = __webpack_public_path__ + "static/amazon-aa1a24bd9a6df48e3939df9df7250ae7.png";